import {
  buildAnonymousTimestampJitterMs,
  shouldJitterAnonymousTimestamp,
} from '@/lib/analytics/anonymous/jitter';
import { buildAnonymousAnalyticsEvent } from '@/lib/analytics/anonymous/policy';
import type { AnonymousValue } from '@/lib/analytics/anonymous/policy';
import { AD_TRACKING_CONSENT_EVENT_PROPERTY } from './constants';

type AnonymousAmplitudeEvent = {
  eventName: string;
  properties: Record<string, AnonymousValue>;
  time?: number;
};

export const buildAnonymousAmplitudePayload = (
  eventName: string,
  properties: Record<string, unknown>
): Omit<AnonymousAmplitudeEvent, 'time'> | null => {
  const event = buildAnonymousAnalyticsEvent(eventName, properties);
  if (!event) {
    return null;
  }

  const anonymousProperties: Record<string, AnonymousValue> = {
    ...event.properties,
    [AD_TRACKING_CONSENT_EVENT_PROPERTY]: false,
  };

  return {
    eventName: event.eventName,
    properties: anonymousProperties,
  };
};

export const buildAnonymousAmplitudeEvent = (
  eventName: string,
  properties: Record<string, unknown>
): AnonymousAmplitudeEvent | null => {
  const event = buildAnonymousAmplitudePayload(eventName, properties);
  if (!event) {
    return null;
  }

  return {
    ...event,
    ...(shouldJitterAnonymousTimestamp(event.eventName, event.properties) && {
      time: Date.now() - buildAnonymousTimestampJitterMs(),
    }),
  };
};
